(() => {
  const forms = document.querySelectorAll('[data-ticket-form]');
  if (!forms.length) return;

  const prefillTicketContext = (form) => {
    const orderInput = form.querySelector('input[name="order_number"]');
    const contextInput = form.querySelector('input[name="request_context"]');
    const categorySelect = form.querySelector('select[name="category"]');
    if (!orderInput || !contextInput || !categorySelect || !window.location.hash) return;

    const rawHash = window.location.hash.slice(1).replace(/&amp;/gi, '&');
    if (rawHash.length > 512 || /%(?![0-9a-f]{2})/i.test(rawHash)) return;

    let params;
    try {
      params = new URLSearchParams(rawHash);
    } catch (_) {
      return;
    }

    const orderNumbers = params.getAll('order_number');
    if (orderNumbers.length === 1 && orderNumbers[0].length <= 64 && !orderInput.value) {
      orderInput.value = orderNumbers[0];
    }

    const contexts = params.getAll('request_context');
    const allowedContexts = ['general', 'security_review', 'invoice'];
    if (contexts.length !== 1 || !allowedContexts.includes(contexts[0])) return;

    contextInput.value = contexts[0];
    if (contexts[0] === 'invoice' && Array.from(categorySelect.options).some((option) => option.value === 'invoice')) {
      categorySelect.value = 'invoice';
    }
  };

  forms.forEach((form) => {
    prefillTicketContext(form);

    const submit = form.querySelector('button[type="submit"]');
    const error = form.querySelector('[data-ticket-error]');
    const success = form.querySelector('[data-ticket-success]');
    const endpoint = form.dataset.endpoint;
    const attachmentInput = form.querySelector('input[type="file"][name="attachments[]"]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      error.hidden = true;
      error.textContent = '';
      success.hidden = true;
      success.textContent = '';

      if (!form.reportValidity()) return;

      const attachments = Array.from(attachmentInput?.files || []);
      if (attachments.length > 3) {
        error.textContent = form.dataset.fileCountError || form.dataset.genericError;
        error.hidden = false;
        attachmentInput.focus();
        return;
      }
      if (attachments.some((file) => file.size > 5 * 1024 * 1024)) {
        error.textContent = form.dataset.fileSizeError || form.dataset.genericError;
        error.hidden = false;
        attachmentInput.focus();
        return;
      }

      const previousLabel = submit.textContent;
      submit.disabled = true;
      submit.setAttribute('aria-busy', 'true');

      const formData = new FormData(form);
      const prefix = form.dataset.ticketPrefix?.trim();
      const message = formData.get('message')?.toString() || '';
      if (prefix) formData.set('message', `${prefix}\n\n${message}`);

      try {
        const response = await fetch(endpoint, {
          method: 'POST',
          mode: 'cors',
          credentials: 'omit',
          headers: { Accept: 'application/json' },
          body: formData,
        });
        const result = await response.json().catch(() => ({}));

        if (!response.ok) {
          const firstFieldError = result.errors && Object.values(result.errors).flat()[0];
          throw new Error(result.message || firstFieldError || form.dataset.genericError);
        }

        success.textContent = result.message || '';
        if (result.ticket_url) {
          try {
            const ticketUrl = new URL(result.ticket_url);
            if (ticketUrl.protocol === 'https:' && ticketUrl.hostname === 'admin.rdrsoftware.de') {
              const link = document.createElement('a');
              link.href = ticketUrl.href;
              link.textContent = form.dataset.ticketLinkLabel;
              success.append(document.createTextNode(' '), link);
            }
          } catch (_) {
            // Keep the success confirmation even if the API returns an invalid URL.
          }
        }
        success.hidden = false;
        form.reset();
      } catch (requestError) {
        error.textContent = requestError.message || form.dataset.genericError;
        error.hidden = false;
      } finally {
        submit.disabled = false;
        submit.removeAttribute('aria-busy');
        submit.textContent = previousLabel;
      }
    });
  });
})();
